"use strict";

angular.module('rmApp')
    .run(['$rootScope', '$state', '$stateParams', '$transitions', ($rootScope, $state, $stateParams, $transitions) => {

        /*
        Force desktop view
         */
        let targetWidth = 980;
        let viewport = document.querySelector('meta[name="viewport"]');

        let showFullSite = () => {
            viewport.setAttribute('content', 'width=' + targetWidth);
            localStorage.isResponsive = 'false';
        };

        showFullSite();

        //Lets make a backup, incase something goes wrong.
        $transitions.onStart({ }, (transition) => {

            let toState = transition.to();

            //Lets recreate the locals incase it gets deleted
            if ($state.$current.locals == null) {
                $state.$current.locals = Object();
            }

            let change = [{
                "identifier": "rundown",
                "addapt": "@"
            }, {
                "identifier": "backlog",
                "addapt": "@"
            }];

            change.forEach((param) => {
                if (toState["views"] !== undefined && toState["views"][param["identifier"]] !== undefined) {
                    toState["views"][param["identifier"] + param["addapt"]] = toState["views"][param["identifier"]];
                    $state.$current.locals[param["identifier"] + param["addapt"]] = toState["views"][param["identifier"]];
                    delete toState["views"][param["identifier"]];
                }
            });
        });
    }])
    .controller('ConfirmDialogCtrl', require('./confirm_dialog_ctrl'))
    .controller('SelectBroadcastCtrl', require('./select_broadcast_ctrl.js'))
    .controller('printDialogCtrl', require('./print_dialog_ctrl'))
    .controller('epgInfoDialogCtrl', require('./epg_info_dialog_ctrl'))
    .controller('printRundownDialogCtrl', require('./printRundown_dialog_ctrl'))
    .controller('RejectDialogCtrl', require('./confirm_reject_ctrl'))
    .controller('PromptDialogCtrl', require('./prompt_dialog_ctrl'))
    .controller('ConfirmManyDialogCtrl', require('./confirm_many_dialog_ctrl'))
    .controller('MoveBlockDialogCtrl', require('./move_block_dialog_ctrl'))
    .controller('ShortenBroadcastDialogCtrl', require('./ShortenBroadcastDialogCtrl'))
    .controller('TreeControllerDialogCtrl', require('./treecontroller_dialog_ctrl'))
    .controller('RevisionDialogCtrl', require('./revision_dialog_ctrl'))
    .controller('changeCardInfoDialogCtrl', require('./changeCardInfo_dialog_ctrl'))
    .controller('createCardInfoDialogCtrl', require('./createCardInfo_dialog_ctrl'))
    .controller('stationRemoveDialogCtrl', require('./stationRemove_dialog_ctrl'))
    .controller('stationAddDialogCtrl', require('./stationAdd_dialog_ctrl'))
    .controller('trialMessageCtrl', require('./trialMessage_ctrl'))
    .controller('advancedSearchCtrl', require('./advancedSearch_ctrl'))
    .controller('thumbnailDialogCtrl', require('./thumbnail_dialog_ctrl'))
    .controller('supportDialogCtrl', require('./support_dialog_ctrl'))
    .controller('messageDialogCtrl', require('./message_dialog_ctrl'))
    .controller('usageInstructionsDialogCtrl', require('./usage_instructions_dialog_ctrl'))
    .controller('SocketConnectionLostCtrl', require('./socketConnectionLost_ctrl'))
    .controller('changePasswordDialog', require('./changePassword_dialog_ctrl'))
    .controller('ApplicationUploadDialogCtrl', require('./application_upload_dialog_ctrl'))
    .controller('ApplicationInstallerDialogCtrl', require('./application_installer_dialog_ctrl'))
    .controller('PrintRundownCtrl', require('./print_rundown_ctrl'))
    .controller('PrintEpgCtrl', require('./print_epg_ctrl'))
    .controller('RadioDNSDialogCtrl', require('./radiodns_dialog_ctrl'));